import React from "react";

let currId = 0;
const generateId = (prefix: string) => {
  currId++;
  return `${prefix}-${currId}`;
};

/**
 * Generate a unique id for a component.
 *
 * Useful for a11y labels and tags when composing components.
 *
 * !!! IMPORTANT !!!
 * Do NOT use this in any component which is render on the server side as it will
 * cause hydration errors.
 */
export default (prefix: string = "id") => {
  const [id] = React.useState(() => generateId(prefix));
  return id;
};
